import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { AddOutletLayer } from "../components/AddOutletLayer";
import { AddCategoryLayer } from "../components/AddCategoryLayer";
import SupplierListLayer from "../components/SupplierListLayer";

export const SuppliersListPage = () => {
  return (
    <MasterLayout>
<SupplierListLayer/>
    </MasterLayout>
  );
};
